"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nav = require("@alicd/next/lib/nav");

var _nav2 = _interopRequireDefault(_nav);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _map = require("babel-runtime/core-js/map");

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Item = require("./Item");

var _Item2 = _interopRequireDefault(_Item);

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// github.com/ant-design/ant-design/blob/master/components/anchor/Anchor.tsx@a2e0e40

var Anchor = function (_React$Component) {
    (0, _inherits3.default)(Anchor, _React$Component);

    function Anchor(props) {
        (0, _classCallCheck3.default)(this, Anchor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Anchor.__proto__ || (0, _getPrototypeOf2.default)(Anchor)).call(this, props));

        _this.nextHandle = 0;
        _this.handleScrollUpdate = _this.handleScrollUpdate.bind(_this);
        _this.doRegister = _this.doRegister.bind(_this);
        _this.doUnregister = _this.doUnregister.bind(_this);
        _this.doScrollTo = _this.doScrollTo.bind(_this);

        _this.itemsStore = new _map2.default();

        _this.state = {
            selectedKeys: _this.normalizeKeys(_this.props.selectedKeys || _this.props.defaultSelectedKeys)
        };
        return _this;
    }

    (0, _createClass3.default)(Anchor, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            // console.log(getNode(this.props.container, { replaceBodyWithWindow: true }));
            // PROBLEM: why scroll event does not work on non-window container?
            // PROBLEM: it seems antd does not handle the case that container does not mounted before the Anchor ...
            (0, _util.requestAnimationFrameAsync)().then(function () {
                (0, _util.getNode)(_this2.props.container, { replaceBodyWithWindow: true }).addEventListener("scroll", _this2.handleScrollUpdate, false);
                (0, _util.getNode)(_this2.props.container, { replaceBodyWithWindow: true }).addEventListener("wheel", _this2.handleScrollUpdate, false);
                _this2.handleScrollUpdate();
                _this2.forceUpdate();
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            (0, _util.getNode)(this.props.container, { replaceBodyWithWindow: true }).removeEventListener("scroll", this.handleScrollUpdate, false);
            (0, _util.getNode)(this.props.container, { replaceBodyWithWindow: true }).removeEventListener("wheel", this.handleScrollUpdate, false);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            if (this.props.selectedKeys) {
                this.setState({
                    selectedKeys: this.normalizeKeys(this.props.selectedKeys)
                });
            }
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            return {
                cruiAnchorContainer: (0, _util.getNode)(this.props.container, { replaceBodyWithWindow: true }),
                cruiAnchorAnimation: this.props.animation,
                cruiAnchorDoRegister: this.doRegister,
                cruiAnchorDoUnregister: this.doUnregister,
                cruiAnchorDoScrollTo: this.doScrollTo
            };
        }
    }, {
        key: "setStateAsync",
        value: function setStateAsync(updater) {
            var _this3 = this;

            return new _promise2.default(function (resolve, reject) {
                _this3.setState(updater, function () {
                    return resolve();
                });
            });
        }
    }, {
        key: "normalizeKeys",
        value: function normalizeKeys(keys) {
            if (!Array.isArray(keys)) {
                if (keys != null) {
                    keys = [keys];
                } else {
                    keys = [];
                }
            } else {
                keys = [].concat((0, _toConsumableArray3.default)(keys));
            }
            return keys;
        }
    }, {
        key: "handleScrollUpdate",
        value: function handleScrollUpdate() {
            // console.log("handleScrollUpdate", this.props.container);
            var currentLinkKey = this.getCurrentLinkKey();
            if (currentLinkKey && this.state.selectedKeys.indexOf(currentLinkKey) == -1) {
                this.setState({ selectedKeys: [currentLinkKey] });
                typeof this.props.onScrollTo == "function" && this.props.onScrollTo(currentLinkKey);
            }
        }
    }, {
        key: "getCurrentLinkKey",
        value: function getCurrentLinkKey() {
            var ret = null;
            var container = (0, _util.getNode)(this.props.container, { replaceBodyWithWindow: true });
            this.itemsStore.forEach(function (_ref, handle) {
                var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                    key = _ref2[0],
                    to = _ref2[1];

                var node = (0, _util.getNode)(to);
                if (node) {
                    var top = (0, _util.getOffsetTop)(node, container);
                    if (top < 16) {
                        if (!ret || ret[0] < top) {
                            ret = [top, key, to];
                        }
                    }
                }
            });
            return ret && ret[1];
        }
    }, {
        key: "doRegister",
        value: function doRegister(key, node) {
            var handle = this.nextHandle;
            this.nextHandle += 1;
            this.itemsStore.set(handle, [key, node]);
            return handle;
        }
    }, {
        key: "doUnregister",
        value: function doUnregister(handle) {
            this.itemsStore.delete(handle);
        }
    }, {
        key: "doScrollTo",
        value: function doScrollTo() {
            _util.scrollTo.apply(undefined, arguments);
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                children = _props.children,
                animation = _props.animation,
                onScrollTo = _props.onScrollTo,
                selectedKeys = _props.selectedKeys,
                rest = (0, _objectWithoutProperties3.default)(_props, ["className", "children", "animation", "onScrollTo", "selectedKeys"]);


            return _react2.default.createElement(
                _nav2.default,
                (0, _extends3.default)({
                    className: (0, _classnames2.default)("cn-anchor", className)
                }, rest, {
                    selectedKeys: this.state.selectedKeys
                }),
                children
            );
        }
    }]);
    return Anchor;
}(_react2.default.Component);

Anchor.propTypes = {
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    animation: _propTypes2.default.bool,

    onScrollTo: _propTypes2.default.func,
    selectedKeys: _propTypes2.default.arrayOf(_propTypes2.default.any),
    defaultSelectedKeys: _propTypes2.default.arrayOf(_propTypes2.default.any)
    // container: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.string]),
};
Anchor.defaultProps = {
    container: function container() {
        return document.body;
    },
    animation: true,
    defaultSelectedKeys: []
};
Anchor.childContextTypes = {
    cruiAnchorContainer: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
    cruiAnchorAnimation: _propTypes2.default.bool,
    cruiAnchorDoRegister: _propTypes2.default.func,
    cruiAnchorDoUnregister: _propTypes2.default.func,
    cruiAnchorDoScrollTo: _propTypes2.default.func
};
exports.default = Anchor;


Anchor.Item = _Item2.default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-anchor@0.0.6@@alicd/crui-anchor/lib/Anchor.js
// module id = 590
// module chunks = 0